import { IAggFuncParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-enterprise';
import { formatDollar } from '../../../../../helpers/formatters';

function dollarFormatter(params: ValueFormatterParams) {
    return formatDollar(params.value, 2, true);
}

function sumDefZero(params: IAggFuncParams<number>) {
    let ret = 0;
    params.values.forEach((v: number) => {
        if (v) {
            ret += v;
        }
    });
    return ret;
}

export const columnDefs = [
    {
        headerName: 'Total Insured Value',
        field: 'totalInsurableValue',
        valueGetter: (params: ValueGetterParams) => params.data?.totalInsurableValue || 0,
        valueFormatter: dollarFormatter,
        aggFunc: sumDefZero,
    },
    {
        headerName: 'Premium',
        field: 'boundPremium',
        valueGetter: (params: ValueGetterParams) => params.data?.boundPremium || 0,
        valueFormatter: dollarFormatter,
        aggFunc: sumDefZero,
    },
    {
        headerName: 'Insured',
        field: 'namedInsured',
    },
    {
        headerName: 'Location Address',
        valueGetter: (params: ValueGetterParams) => {
            if (params.data) {
                const { address1, address2, city, state, zip } = params.data;
                if (!address1) {
                    return '--';
                }
                return `${address1}${address2 ? ', ' + address2 : ''}`;
            }
            return '';
        },
    },
    {
        headerName: 'City',
        field: 'city',
    },
    {
        headerName: 'State',
        field: 'state',
    },
    {
        headerName: 'Zip',
        field: 'zip',
    },
    {
        headerName: 'Aop Ded.',
        field: 'aopDeductible',
    },
    {
        headerName: 'Water Dmg Ded.',
        field: 'wdDeductible',
    },
    {
        headerName: 'WHH Ded.',
        field: 'whhDeductible',
    },
    {
        headerName: 'Flood Ded.',
        field: 'floodDeductible',
    },
    {
        headerName: 'EQ Ded.',
        field: 'quakeDeductible',
    },
    {
        headerName: 'Eff. Date',
        field: 'effectiveDate',
    },
    {
        headerName: 'Exp. Date',
        field: 'expirationDate',
    },
    {
        headerName: 'Primary',
        field: 'primaryLimit',
    },
    {
        headerName: 'Rate',
        field: 'finalRate',
    },
    {
        headerName: 'Policy No.',
        field: 'policyNumber',
    },
];
